import styled from "styled-components";
import { SpaceBetween } from "../../Theme";

export const Container = styled(SpaceBetween)`
  padding: 3px 3px;
  border-bottom: "" 1px solid #ccc;
  &:hover {
    font-weight: bold;
  }
  @media (min-width: 426px) {
    padding: 15px;
  }
`;

export const Actions = styled.div`
  margin-left: 40px;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  & > * {
  }
`;

export const ProductName = styled.div`
  width: 100%;
  margin-left: 20px;
  cursor: pointer;
`;

export const MobileHidden = styled.div`
  display: none;
  @media (min-width: 426px) {
    display: block;
  }
`;

export const ActionOpacity = styled(SpaceBetween)`
  ${({ disabled }) => disabled && "color:#ddd"}
`;
